import React from 'react';

const BookDetails = ({ title, author, coverUrl, description }) => (
  <div className="bg-white shadow-lg rounded-lg overflow-hidden">
    <div className="md:flex">
      <div className="md:flex-shrink-0">
        <img className="h-48 w-full object-cover md:w-48" src={coverUrl} alt={title} />
      </div>
      <div className="p-8">
        <div className="uppercase tracking-wide text-sm text-purple-600 font-semibold">Current Book</div>
        <h2 className="block mt-1 text-2xl leading-tight font-bold text-gray-900">{title}</h2>
        <p className="mt-2 text-gray-600">by {author}</p>
        <p className="mt-4 text-gray-700">{description}</p>
      </div>
    </div>
  </div>
);

const PreviousBook = ({ title, author, rating }) => (
  <li className="py-4">
    <div className="flex items-center space-x-4">
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-900 truncate">{title}</p>
        <p className="text-sm text-gray-500 truncate">by {author}</p>
      </div>
      <div className="inline-flex items-center text-base font-semibold text-yellow-500">
        {"★".repeat(rating)}{"☆".repeat(5-rating)}
      </div>
    </div>
  </li>
);

const BookClub = () => {
  const currentBook = {
    title: "The Midnight Library",
    author: "Matt Haig",
    coverUrl: "https://images-na.ssl-images-amazon.com/images/I/81YzHKeWq7L.jpg",
    description: "Between life and death there is a library, and within that library, the shelves go on forever. Every book provides a chance to try another life you could have lived. In The Midnight Library, Matt Haig's enchanting blockbuster novel, Nora Seed finds herself faced with this decision."
  };

  const previousBooks = [
    { id: 1, title: "The Seven Husbands of Evelyn Hugo", author: "Taylor Jenkins Reid", rating: 5 },
    { id: 2, title: "Circe", author: "Madeline Miller", rating: 4 },
    { id: 3, title: "The Vanishing Half", author: "Brit Bennett", rating: 5 },
    { id: 4, title: "The Song of Achilles", author: "Madeline Miller", rating: 4 },
    { id: 5, title: "Where the Crawdads Sing", author: "Delia Owens", rating: 3 },
  ];

  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">Munich Girls Book Club</h1>
      
      <div className="mb-12">
        <BookDetails {...currentBook} />
      </div>
      
      <div className="bg-white shadow overflow-hidden sm:rounded-lg">
        <div className="px-4 py-5 sm:px-6">
          <h2 className="text-2xl leading-6 font-bold text-gray-900">Previous Books</h2>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">Our reading journey so far</p>
        </div>
        <div className="border-t border-gray-200">
          <ul className="divide-y divide-gray-200 px-4 sm:px-6">
            {previousBooks.map(book => (
              <PreviousBook key={book.id} {...book} />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default BookClub;